import {useDispatch, useSelector} from 'react-redux';

import {ApiDispatchForToolkit} from 'src/openapi/admin/types';

import type {AppState} from './typedef';
import type {TypedUseSelectorHook} from 'react-redux';

export const useAppDispatch = () => useDispatch<ApiDispatchForToolkit>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
